import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  CannedResponseSchema,
  CannedResponseSchemaData,
} from './canned-response.schema';

export const cannedResponseContract = createRESTContract({
  getCannedResponses: {
    method: 'GET',
    path: '/canned-response',
    permissions: [PERMISSIONS.CANNED_RESPONSE.CANNED_RESPONSE_LIST],
    response: z.array(CannedResponseSchema),
  },
  createCannedResponse: {
    method: 'POST',
    path: '/canned-response',
    permissions: [PERMISSIONS.CANNED_RESPONSE.CANNED_RESPONSE_CREATE],
    response: CannedResponseSchema,
    body: CannedResponseSchemaData,
  },
  updateCannedResponse: {
    method: 'PUT',
    path: '/canned-response/:id',
    permissions: [PERMISSIONS.CANNED_RESPONSE.CANNED_RESPONSE_EDIT],
    response: z.void(),
    body: CannedResponseSchemaData,
  },
  removeCannedResponse: {
    method: 'DELETE',
    path: '/canned-response/:id',
    permissions: [PERMISSIONS.CANNED_RESPONSE.CANNED_RESPONSE_REMOVE],
    response: z.void(),
    body: z.undefined(),
  },
});
